// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "Benachrichtigen Sie den Client zum Springen",
  "1d484fee4a": "Finanzabteilung, Vertriebsabteilung, Projektmanagement, Geschäftsdaten, Produktabteilung, Betriebsabteilung, Forschungs- und Entwicklungsmanagement, Versionsplanung, Kundendienstabteilung, Verwaltungsabteilung, Einkaufsabteilung, After-Sales-Management",
  "a2c88dfb79": "Erstellen Sie Ihr erstes Team",
  "3cfdcc6086": "Finanzabteilung, Vertriebsabteilung, Projektmanagement/305, Personalverwaltung/306, Betriebsabteilung, Forschungs- und Entwicklungsmanagement, Versionsplanung, Kundenbetreuung/403, Einkaufsabteilung, After-Sales-Management",
  "ac45ec2c05": "Anmeldeüberprüfung fehlgeschlagen",
  "9aef9b8ccd": "Das aktuell angemeldete Konto ist unerwartet. Bitte melden Sie sich erneut an und versuchen Sie es erneut",
  "728dd00f22": "Die Überprüfung dieser Telefonnummer ist fehlgeschlagen. Bitte versuchen Sie, sich mit dem SMS-Code anzumelden",
  "30dbecd916": "Ihre Eingaben enthalten sensible Wörter. Bitte ändern Sie diese und versuchen Sie es erneut",
  "12ed508d8a": "Sie führen zu viele Aktionen in kurzer Zeit durch. Bitte versuchen Sie es später erneut",
  "952d4a7595": "Der Anmeldestatus des aktuellen Kontos ist unerwartet. Bitte melden Sie sich erneut an und versuchen Sie es erneut",
  "e64bfdeaa4": "Anmeldeüberprüfung fehlgeschlagen. Bitte erhalten Sie den SMS-Code erneut",
  "79008a65f1": "Diese Telefonnummer ist mehreren Unternehmen zugeordnet. Bitte melden Sie sich beim Unternehmen an oder ändern Sie die Telefonnummer",
  "bf242eff42": "Der Unternehmensname existiert bereits",
  "4f0cdb8374": "Bitte geben Sie die vollständige Telefonnummer ein. Wenn Sie eine internationale Telefonnummer verwenden, wechseln Sie zu einer inländischen Nummer (86+)",
  "46e79ffeff": "Fehler beim Erstellen des Unternehmens. Bitte wenden Sie sich an den offiziellen Kundenservice",
  "f3e18f0341": "Parameterüberprüfung fehlgeschlagen",
  "503fd1718d": "Fehler beim Senden des SMS-Codes",
  "24b3129f19": "SMS zu häufig gesendet. Bitte versuchen Sie es später erneut",
  "1cde3e8245": "Der Verifizierungscode ist falsch. Bitte geben Sie ihn erneut ein",
  "4212ecc031": "Mehrfach fehlerhafte Eingaben. Überprüfung vorübergehend gesperrt. Bitte versuchen Sie es später erneut",
  "735da9c347": "Die Überprüfung auf doppelte Unternehmensnamen ist fehlgeschlagen. Bitte wenden Sie sich an den offiziellen Kundenservice",
  "8731da9615": "Die Überprüfung der Unternehmensnamenzertifizierung ist fehlgeschlagen. Bitte wenden Sie sich an den offiziellen Kundenservice",
  "62e89b3f16": "Dienstleistungsvereinbarung akzeptieren",
  "c9b79027e5": "Code senden",
  "84c1447b9d": "Erfolgreich kopiert",
  "fba4b0abd0": "Host-Datensatz",
  "37f5a7cd41": "TXT-Wert",
  "78b12427c9": "Wird authentifiziert...",
  "59d089837c": "Wir können Ihre Domain derzeit nicht verifizieren. Möglicherweise müssen Sie eine Weile warten, damit Ihr Domain-Hosting-Anbieter Ihre Informationen aktualisiert. Wenn es nach einiger Zeit immer noch keine Reaktion gibt, versuchen Sie, die Domain erneut zu verifizieren oder ändern Sie die Domain.",
  "4a5b7383d1": "Domain Wird Überprüft",
  "f24a492e40": "Überprüfen Eintrags, Sie Können Diese Seite Schließen Und Später Zurückkommen.",
  "c697ca5f1a": "Willkommen Bei Der Unternehmensversion",
  "ebb01b1740": "Weiter",
  "30109bf753": "Hat Ihr Unternehmen Eine Domain?",
  "2b3e485b47": "Ich Habe Eine Unternehmensdomain",
  "1a7f5eae44": "Ich Habe Keine Unternehmensdomain",
  "bde15d6d84": "Sie Müssen Eine Domain (Z.B. Beispiel.com) Haben, Um Ein Unternehmenskonto Für Sie Zu Erstellen.",
  "07ffb22c90": "Entschuldigung, Sie Müssen Eine Domain Haben, Um Ein Unternehmenskonto Für Ihr Unternehmen Zu Erstellen.",
  "de23836563": "Bitte Geben Sie Die Domain Ein, Die Zum Erstellen Eines Unternehmenskontos Verwendet Wird.",
  "287c07944a": "Validieren Sie Ihre Domain",
  "3ea2d528d5": "Führen Sie Die Folgenden Schritte Aus, Um Zu Beweisen, Dass Sie Der Eigentümer Von <b>{domain}</b> Sind Und Um Andere Daran Zu Hindern, Diese Domain Für Die Registrierung Eines Unternehmenskontos Zu Verwenden.",
  "082b18ce56": "a. Öffnen Sie Einen <b>Neuen Tab</b> Und Gehen Sie Auf Die Website Ihres Domain-Hosting-Providers, Dann <b>Melden</b> Sie Sich In Ihrem Konto An.",
  "4f7e0841a9": "b. Wechseln Sie Auf Der Website Des Domain-Hostings In Den <b>DNS-Bereich</b>. Der Name Des DNS-Bereichs Auf Der Website Ihres Domain-Hostings Kann Unterschiedlich Sein, Z. B. Als <b>DNS-Verwaltung, Nameserver-Verwaltung, Steuerungspanel Oder Erweiterte Einstellungen</b> Angezeigt Werden.",
  "6365ad6e3a": "Kehren Sie Dann <b>Hierher Zurück</b> Und Klicken Sie Auf „Weiter“, Um Einen Überprüfungseintrag Hinzuzufügen.",
  "8528892080": "Überprüfungseintrag Hinzufügen",
  "7a225304f8": "a. Scrollen Sie Im DNS-Bereich Zum <b>TXT</b>-Teil Und Klicken Sie Auf Den Relevanten Button, Um Einen Eintrag Hinzuzufügen.",
  "b3cb7d947c": "b. Alle Nachstehenden Werte <b>Kopieren Und Einfügen</b> Auf Der <b>TXT-Formular</b>-Seite Ihres Domain-Hosting-Providers.",
  "47213583bf": "c. <b>Speichern</b> die Aufzeichnungen auf der Website des Domain-Hosting-Dienstes, <br> dann <b>hier zurückkehren</b> und unten auf 'Domain Bestätigen' klicken",
  "21486a57cf": "Hinweis: Im Namen/Host/Alias-Feld können Sie '@' eingeben oder es leer lassen. Der Domain-Hosting-Dienst kann auch verlangen, dass Sie die Domain (Ihre-Domain.com) in diesem Feld eingeben. Sie können anhand anderer DNS-Einträge entscheiden, wie Sie dieses Feld ausfüllen. Im TTL-Feld geben Sie '86400' ein oder behalten den Standardwert bei.",
  "f1b8edab9c": "Domain wechseln",
  "7c6fc663a8": "Domain Bestätigen",
  "b6aee9dc0d": "Domain-Überprüfung erfolgreich",
  "dd4cc429ea": "Es ist bewiesen, dass Sie der Besitzer von",
  "450f5c9230": "sind und dass kein anderer Benutzer diese Domain verwenden darf, um ein Unternehmensaccount zu registrieren.",
  "71cbcba755": "Klicken Sie auf 'Weiter', um die Erstellung des Unternehmensaccounts abzuschließen.",
  "f4084f4870": "Bitte legen Sie Ihr Login-Konto fest.",
  "fe3138baec": "Erstellung abschließen",
  "0315cddedb": "Unternehmenserstellung erfolgreich",
  "91454a7f34": "Gehen Sie nun zum Login in das Verwaltungsbackend, um Unternehmensaccounts für die Mitglieder Ihres Unternehmens zu erstellen.",
  "366304cde7": "1. Sie werden automatisch vom aktuellen WPS-Account abgemeldet.",
  "8a9f2a8422": "2. Sie müssen sich mit Ihrem Unternehmenskonto {account}@{domain} im Verwaltungsbereich anmelden",
  "43e265e998": "Zum Login im Verwaltungsbackend gehen",
  "9240efaaf0": "SMS ist gesendet",
  "e424bb9a6d": "Bitte eingeben",
  "d44d581706": "Firmenname",
  "aa8679f406": ", 4 bis 30 Zeichen",
  "581bdb1f98": ", darf keine Sonderzeichen \\ / : * ? &quot; &lt; &gt; | {} enthalten",
  "c13cabb67a": "E-Mail:",
  "2b9b429e46": "Ihre E-Mail",
  "5ed834a7df": "Bitte geben Sie Ihre E-Mail-Adresse ein.",
  "acfd1f02ed": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  "31c7c92cca": "Maximal 80 Zeichen",
  "3f27cf84b3": "Bitte geben Sie den Bestätigungscode ein.",
  "a0ae1f3ec4": "Bestätigungscode ist falsch",
  "e5589c5e74": "Ihr Name",
  "69d7bd63f6": ", nur chinesische Zeichen, Buchstaben und Zahlen erlaubt",
  "91f008d258": ", maximal 8 Zeichen",
  "6ea6c9b39b": "Telefon",
  "161042c5b7": "Bitte geben Sie Ihre Telefonnummer ein.",
  "e6b8eab1cd": "Bitte geben Sie Ihre Telefonnummer ein, 11-stellige Nummer.",
  "3fd5fbb3cc": "Bitte geben Sie Ihre Domain ein.",
  "cb5346ba8e": "Bitte geben Sie eine gültige Unternehmensdomain ein, 4 bis 30 Zeichen.",
  "27928eb7a4": "Konto",
  "8e19bd444d": "Bitte geben Sie den Login-Namen ein.",
  "7bbbf479dc": "4-20 Zeichen, nur Zahlen, Buchstaben oder Unterstriche",
  "3d84cae479": "Bitte geben Sie ein Konto ein, das den Anforderungen entspricht / Der erste Buchstabe muss ein Buchstabe oder eine Zahl sein",
  "c0d5ece1a7": "Kennwort",
  "f444036fa8": "Kennwort eingeben",
  "b03218d72b": "12-16 Stellen für das Passwort, das aus Groß- und Kleinbuchstaben, Zahlen oder einer Dreierkombination besteht",
  "b4ab05df50": "*Ihr Unternehmen hat bereits jemanden, der Ihre Domain für ein Firmenkonto verwendet. Bitte kontaktieren Sie den Kundenservice (400-677-5005), um nachzuweisen, dass Sie Eigentümer dieser Domain sind.",
  "c58876008f": "Kopieren fehlgeschlagen, bitte versuchen Sie es erneut",
  "86f73420de": "Einladungslink",
  "a58861962c": "Entschuldigung, Ihr aktueller Browser unterstützt das Herunterladen dieses QR-Codes nicht",
  "228db07f78": "Abteilung Finanzen, Vertrieb, Projektmanagement, Geschäftsdaten, Produktabteilung, Betrieb, Forschung und Entwicklung Management, Versionsplanung, Kundenservice, Verwaltung, Einkauf, After-Sales Management",
  "93896d7e98": "Team erstellen und mit Kollegen beginnen zu arbeiten",
  "e8f66fb75c": "Abteilung Finanzen, Vertrieb, Projektmanagement/305, Personalwesen/306, Betrieb, Forschung und Entwicklung Management, Versionsplanung, Kundenservice/403, Einkauf, After-Sales Management",
  "831b73da9b": "Der Name darf keine illegalen Zeichen und Sonderzeichen /\\;:*?\"<>|%& enthalten",
  "51ab33b3ee": "Parameter nicht korrekt",
  "a297f9e951": "Unternehmensname ist bereits vergeben",
  "04d60ed5f5": "Verbotene Wörter dürfen nicht verwendet werden",
  "2ff7bef083": "Domain-Format fehlerhaft",
  "41e1ba2165": "Überprüfung der Domain-TXT-Informationen fehlgeschlagen",
  "50f348caa9": "Konto dupliziert",
  "9d4c950d65": "Dieser Name wird bereits verwendet",
  "38cf19ed95": "Dieser Institutionsname existiert bereits",
  "4b426e7c9c": "Institutionsname",
  "298f880e18": "Bereits vorhanden, wir empfehlen Ihnen, weitere Informationen hinzuzufügen:",
  "1e67dd20b3": "Institutionsname wiederherstellen",
  "517107cb04": "Anderen Namen verwenden",
  "5667081882": "Diesen Namen für die Erstellung verwenden",
  "e306a979a6": "Schnelles Ausfüllen:",
  "f583db96e0": "*Wenn der Institutionsname belegt ist, können Sie",
  "9767148e34": "Bitte geben Sie einen Unternehmens- oder Organisationsnamen ein, 2~120 Buchstaben",
  "e0e0ec159f": "Institutionsname",
  "5b13d254c0": "Dieser Unternehmensname existiert bereits",
  "92027671ec": "Unternehmensname",
  "36d482a7fb": "Unternehmensname wiederherstellen",
  "79058a7577": "*Wenn der Firmenname belegt ist, können Sie",
  "c96dd48dba": "Unternehmensname",
  "842efad336": "*Falls Sie Unternehmensmitarbeiter sind,",
  "860f9bd77b": "Kundendienst",
  "5a7ed18daf": "Dem Unternehmen beitreten",
  "ab470e9ace": "Kontaktinformationen hinterlegen",
  "0a7e0e48a7": "Name des zu beantragenden Unternehmens:",
  "a8dc318dcc": "Bitte überprüfen Sie Ihre angegebenen Kontaktinformationen, der Plattform-Kundenservice wird Sie später kontaktieren",
  "6ea1f4d7f5": "Daten übermitteln",
  "d439e39f43": "Ihre Daten wurden erhalten",
  "884653426b": "Der Kundenservice wird Sie innerhalb von 24 Stunden anrufen. Bitte achten Sie darauf, den Anruf anzunehmen!",
  "2361cb14bf": "Scannen Sie den QR-Code mit WeChat, um den Online-Kundendienst hinzuzufügen und den Fortschritt zu erfahren.",
  "50f45d0031": "Speichern fehlgeschlagen",
  "fc856d0fd2": "Superadministrator",
  "e16c0676d2": "Administrators",
  "b1d2ddd126": "Normales Mitglied",
  "9d322cc08d": "Der Name des Instituts darf keine Sonderzeichen \\/:*?\"<>|{} enthalten",
  "b583ba7363": "Der Name des Unternehmens darf keine Sonderzeichen \\/:*?\"<>|{} enthalten",
  "1d118a9bad": "Der Name der Institution muss mindestens 2 Zeichen lang sein. Bitte geben Sie einen Institutsnamen mit 2 bis 120 Zeichen ein.",
  "441b45b1f5": "Der Firmenname muss mindestens 2 Zeichen lang sein. Bitte geben Sie einen Firmennamen mit 2 bis 120 Zeichen ein.",
  "97457cb1f0": "Der Name der Institution darf 120 Zeichen nicht überschreiten. Bitte geben Sie einen Institutsnamen mit 2 bis 120 Zeichen ein.",
  "8ce00d3b92": "Der Unternehmensname darf 120 Zeichen nicht überschreiten. Bitte geben Sie einen Firmennamen mit 2 bis 120 Zeichen ein.",
  "a72778d3de": "Der Name muss mindestens 2 Zeichen lang sein. Bitte geben Sie einen Namen mit 2 bis 10 Zeichen ein.",
  "79c17db5de": "Der Name darf 10 Zeichen nicht überschreiten. Bitte geben Sie einen Namen mit 2 bis 10 Zeichen ein.",
  "482a118202": "Der Name unterstützt nur chinesische Zeichen, Zahlen, englische Buchstaben und ·",
  "9a9be18941": "Bitte ankreuzen",
  "e6b7c4aa66": "Online-Service-Vereinbarung",
  "595023d905": "Institution erstellen",
  "ba8c2df551": "Gemeinsame Speicherorte ausblenden",
  "d284384975": "Online-Servicevereinbarung",
  "5c266d5a84": "Datenschutzerklärung",
  "fcb92dbcf6": "Cloud-Office-Servicevereinbarung",
  "2ae7a8a3f7": "Vielen Dank, dass Sie WPS 365 Cloud Office ausgewählt haben. Hier finden Sie die rechtlichen Vereinbarungen zwischen Ihnen und/oder der von Ihnen vertretenen Organisation und Kingsoft Office bezüglich der Registrierung, des Abonnements und der Nutzung dieses Dienstes.",
  "d30a6983bd": "Bitte lesen Sie {0} | {1} | {2}, klicken Sie auf „Zustimmen“, um die Inhalte der Vereinbarung zu akzeptieren und unsere Dienste zu nutzen.",
  "263e306ede": "Ich habe gelesen und stimme zu {0} | {1} | {2}",
  "440129c0f1": "Bitte geben Sie {0} ein",
  "8ab916983d": "Firmenname",
  "b01d68543b": "Ihr Name",
  "684b30d4e9": "Ihre Telefonnummer",
  "a48427e8e2": "Verwendet, um eine Arbeitsplattform für Ihr Unternehmen zu erstellen",
  "3a81b0f1fc": "Damit Kollegen Sie im System finden und zusammenarbeiten können",
  "52bc539b6e": "Bestätigung erstellen",
  "b2fe245e19": "Unternehmen/Team erstellen: Dateifreigabe und Zusammenarbeit",
  "893282d3f7": "Bitte ergänzen Sie die Unternehmensinformationen:",
  "cc997bf6aa": "Bestätigen",
  "50fdde51ac": "{0}, {1}~{2} Zeichen",
  "a19cc5ec18": "{0}, darf keine Sonderzeichen \\u005C/:*?\"<>|{} enthalten",
  "26857f28f9": "{0}, nur chinesische Zeichen, Buchstaben und Zahlen eingeben",
  "f4080b1431": "{0}, maximal {1} Zeichen",
  "88e59b2d58": "{0}, 11-stellige Nummer",
  "91d6d4e105": "Bitte geben Sie den Bestätigungscode ein",
  "bec71bde96": "Bestätigungscode ist nicht korrekt",
  "e20ff8ee19": "{0} ist erforderlich",
  "8dc09d10d7": "dwId nicht gefunden",
  "a03766ce6c": "Schule",
  "03542addfe": "Unternehmen",
  "adb8a815d1": "Telefonnummer zu {0} erreichen die Grenze",
  "97a6b66f1d": "Die aktuelle Telefonnummer ist bereits mit {0} verbunden",
  "665e465487": "Kann {0} nicht erstellen, die aktuelle Telefonnummer „<strong>{1}</strong>“ hat die maximale Anzahl an gebundenen {0} erreicht (maximal 5 {2} können gebunden werden), Sie können auf die unten angefügten gebundenen {3} zugreifen:",
  "a85b1367ca": "Die aktuelle Telefonnummer „{0}“ ist mit {1} verbunden, Sie können einen bestehenden {2} auswählen oder ein neues {3} erstellen:",
  "bf992ce17b": "Verwenden Sie eine andere Telefonnummer, um {0} zu erstellen",
  "395ea04444": "Neues {0} erstellen",
  "4ce3bb86b3": "Beitrittslimit für {0} überschritten",
  "df88c4b7a5": "Die aktuelle Telefonnummer „{0}“ hat das {1} Limit erreicht",
  "78f7dd59ca": "Die aktuelle Telefonnummer „{0}“ ist verbunden mit folgenden {1}, Sie können direkt wechseln",
  "8db491a3f8": "Weiter neues {0} erstellen",
  "83f6d9e1e4": "Versuche es noch einmal",
  "1dc5f11612": "oder",
  "217d76f53e": "Feedback",
  "b69a6ea62a": "Bitte halten Sie die linke Maustaste gedrückt, um zwei Schilde freizurubbeln",
  "3a31f64800": "Herzlichen Glückwunsch, Sie haben einen Schild freigerubbelt<br/>Fahren Sie fort",
  "6a81fcee96": "Wird geladen",
  "e97877a65d": "Oh nein, der Schild ist verschwunden<br/>Bitte",
  "8d85456145": "Ich habe zu lange gewartet<br/>Bitte",
  "77ad847b95": "Das Netzwerk ist wirklich schlecht<br/>Bitte",
  "dbd1ae3a34": "Sie haben zu schnell gerubbelt<br/>Bitte",
  "bd8e05cd53": "Klicken Sie auf die Schaltfläche, um die intelligente Verifizierung zu starten",
  "63d2a8a722": "Verifizierung erfolgreich",
  "73141928ad": "Verifizierung fehlgeschlagen, bitte klicken Sie auf die Schaltfläche zum Aktualisieren",
  "04856c5c8a": "Intelligente Erkennung läuft",
  "52cd9bd26d": "Ihre Handlung ist nicht autorisiert",
  "fd157e8ea8": "Erstellungsguide",
  "c6225c5b2b": "Willkommen bei der Unternehmensversion",
  "e33423fb1e": "Erstellung erfolgreich",
  "7b0c035999": "Erfolgreiche Erstellung von Kingsoft Doc Unternehmen",
  "85db8faae0": "Unternehmensbenutzeranleitung",
  "20591b9b44": "Unternehmensname wiederherstellen",
  "b023d76dc2": "Mitglied-Hochladeleitfaden",
  "e2f454e095": "{0}'s Unternehmen",
  "df466f942b": "Zweigstelle",
  "26a7b797c4": "Teilzentrum",
  "5fc82b360b": "One-Stop-Büroplattform, um Ihre Arbeit effizienter zu gestalten",
  "f2e736d52e": "Willkommen bei der Unternehmensversion",
  "becc41a35b": "Unternehmensname",
  "74685cdc58": "Bitte geben Sie einen Unternehmens- oder Organisationsnamen ein, 2-120 Zeichen",
  "07b55b1907": "Unternehmensgröße",
  "77b2f763ad": "Bitte wählen Sie die Größe Ihres Unternehmens aus",
  "49d2509109": "Weniger als 5 Personen",
  "8db2c9b74a": "6-20 Personen",
  "a9fb0cf14a": "21-50 Personen",
  "0fed41f8d3": "51-100 Personen",
  "fb33f25a04": "101-200 Personen",
  "3e3ff0f52e": "201-500 Personen",
  "cd8b51f634": "501-2000 Personen",
  "0662fa6eec": "Mehr als 2000 Personen",
  "69334dba1a": "Unternehmensanforderungen",
  "79994e749c": "(Wir werden beste Branchenpraktiken für Unternehmen empfehlen)",
  "840a017f38": "Bitte wählen Sie das Problem, das Sie am meisten lösen möchten",
  "f045b05c73": "Bitte geben Sie Ihre Anforderungen für die Unternehmensgründung ein",
  "d8efb0b36d": "Mehr",
  "adcb8fbb0c": "Häufig genutzte Handynummer",
  "eb1c73e2ca": "Bitte geben Sie Ihre häufig genutzte 11-stellige Handynummer ein",
  "7f276e7dfa": "Kostenlos erstellen",
  "c391b3eec1": "Senden der SMS fehlgeschlagen",
  "54f4cb8fa7": "SMS wurde gesendet",
  "231eb1fa1e": "Unternehmensnutzer {0}",
  "272b0f9d32": "Enterprise-Benutzer",
  "b209a67331": "Erstellung des Unternehmens fehlgeschlagen, bitte Seite aktualisieren.",
  "acb08d0cc9": "Dritter Schritt der Unternehmensgründung",
  "83db361f51": "Nach dem Erstellen wird die Weiterleitungslogik ausgelöst",
  "1e930326e3": "handleStep zum nächsten Schritt",
  "184df5c725": "Fehler beim Speichern des Formulars",
  "736eab3023": "Überprüfen der Einreichung",
  "2db62dc13c": "Überprüfung fehlgeschlagen",
  "54fb0afaea": "Überprüfung erfolgreich",
  "d39cff3fcf": "Überspringen extremer Speicherung, nur um festzustellen, dass ein Verifizierungscode benötigt wird",
  "305b777ae5": "Fehler bei der Namensprüfung öffnet das Popup „Unternehmensname wird verwendet“ und speichert den Namen",
  "e57b6686b2": "Überprüfen, ob der Authentifizierungsträger bereits authentifiziert ist, öffnet ein Authentifizierungsschutz-Popup & speichert die entsprechenden Authentifizierungsthemeninformationen",
  "f7c86f496d": "Namenskonflikt || Verifizierungscode abgelaufen. Wenn nicht bestanden, wird die Ausführung verhindert",
  "cb37db4fd4": "handleSubmit fehlgeschlagen",
  "243a569fc4": "Dieser Name ist bereits registriert. Bitte verwenden Sie einen anderen Namen",
  "196851a3d9": "Unternehmensnutzer {0}",
  "0c3a3595ff": "Enterprise-Benutzer",
  "a33b41e0f2": "Erstellung des Unternehmens fehlgeschlagen, bitte Seite aktualisieren.",
  "fcce6a7156": "Erfolgreich erstellt",
  "5ec6da58a6": "Benachrichtigung an den Client",
  "259c9dfa4e": "Pro-Version-Logik",
  "864156930f": "VBA-Logik",
  "7824efd172": "WPS Docs Mobile",
  "52b6cfaaaf": "WPS Client",
  "c7c51beea9": "Bildungsversion",
  "8d054d4986": "Standardclient",
  "b597e18fb1": "isWps365PcClient und hat openurl",
  "b0c13de2a0": "isWps365PcClient oder kein Client, hat openurl",
  "7d0f2ce18c": "isWps365PcClient oder kein Client, hat openurl Erfolg Rückruf",
  "e2c5a07df6": "Kein Client Kein Openurl",
  "29e0414d1f": "Kein Client Kein Openurl Callback",
  "60861f7d2a": "AutoChange Überlassen Sie der Geschäftspartei das Umschalten",
  "7c83140d90": "Gaststatus erstellt, SDK-Umschaltung nicht erforderlich (SDK unterstützt Gäste nicht), Code hat Interface erfolgreich umgeschaltet",
  "3379b09e59": "Hat Openurl und verwendet Href zum Umschalten",
  "586ff04c22": "Nur Weiterleitung",
  "b6c91f218b": "UseSuccessSkip fehlgeschlagen",
  "47d2f3ba66": "Mehr",
  "57551f86ce": "Je nach UTM-Quelle zu verschiedenen Methoden weiterleiten",
  "64fe3758e2": "Ihre Operation ist nicht autorisiert",
  "4da3e1262f": "Erfolgreich erstellt, beginnen Sie Ihre Unternehmensreise",
  "c38dfb8c6c": "Erstellen Sie Ihr erstes Team",
  "38dddb483b": "Unternehmensbeitritt",
  "614d9c91eb": "Laden Sie Mitglieder ein",
  "97f1eca0aa": "Unternehmensbeitritt",
  "13a4939e90": "Einladung zur Unternehmensmitgliedschaft",
  "a319e4ae0a": "Kollegen einladen",
  "12e4da6bba": "Kollegen sofort einladen",
  "bd885380f6": "Einladungslink abrufen fehlgeschlagen",
  "5e626c4063": "SMS wurde gesendet",
  "3dc09e7cfd": "Die Anzahl der Unternehmensnamen, die Sie wiederherstellen möchten, hat das Limit erreicht",
  "48318f41f9": "Laden Sie Mitglieder ein",
  "45441baac4": "Laden Sie Sie ein, um mit {0} zusammenzuarbeiten",
  "e5847fbd67": "Link kopieren, um Mitglieder einzuladen",
  "23101dd40a": "Eine Lösung wird für Sie zugeschnitten",
  "71bb7e54a8": "Projektmanagement",
  "aff37c79cc": "Gewählte Lösung erleben",
  "a97b174258": "Laden Sie 2 Kollegen ein, um die folgenden Unternehmensvorteile kostenlos zu erhalten.",
  "253855849f": "Den Einladungslink im Arbeitschat teilen und Kollegen einladen",
  "57b0a2a63f": "Link kopieren, Kollegen einladen",
  "71c0a37ee1": "Unternehmensbeitritt",
  "f848c60e0e": "Laden Sie <color:red>2</> weitere Kollegen ein und erhalten Sie kostenlos folgende Unternehmensvorteile",
  "664e32b4fe": "Einladungsseite Unternehmensbeitritt",
  "872f14403a": "Kollegen einladen",
  "1880e7deb9": "Kollegen sofort einladen",
  "cc2a9aaf82": "Erfolgreich erstellt",
  "02a13e2583": "Laden Sie 2 Kollegen ein, um die folgenden Unternehmensvorteile kostenlos zu erhalten.",
  "5d3593cdce": "Teaminformationen abrufen fehlgeschlagen",
  "c025113ea1": "Einladungslink abrufen fehlgeschlagen",
  "b83bc1e485": "Link-Einladung",
  "0996ced9f6": "Entschuldigung, Ihr aktueller Browser unterstützt das Herunterladen dieses QR-Codes nicht",
  "1e88451e31": "Einladungslink wurde kopiert",
  "bb969cabcd": "Kopieren fehlgeschlagen, bitte erneut versuchen",
  "15e1f79c7a": "Ein Unternehmensbeitritt beantragen",
  "59c22b4ef8": "Einen Einladungslink erhalten",
  "0f0b392e60": "Erstellen Sie Ihr Erster Team",
  "0437d07c43": "Firmenname",
  "41800c7bf1": "Bitte Geben Sie Den Namen Des Erstellers Ein",
  "1ec5999511": "Der Erstellername Darf Maximal 8 Zeichen Haben",
  "02da35b4e4": "Der Erstellername Darf Nur Chinesische Zeichen, Buchstaben Oder Zahlen Enthalten",
  "184e9f6616": "Bitte Geben Sie Die Telefonnummer Ein",
  "9b587898ba": "Bitte Geben Sie Die Telefonnummer Im Richtigen Format Ein",
  "e68c164a02": "Bitte Geben Sie Ihre E-Mail Adresse Ein",
  "0b1de22df7": "Bitte Geben Sie Die E-Mail Adresse Im Richtigen Format Ein",
  "61026181ab": "Handelsregistereintrag Ist Erforderlich",
  "c3847e604e": "Dateigröße Überschreitet 10 MB, Bitte Neu Auswählen",
  "49450f4ec7": "Rechtsbeschwerdeformular Ist Erforderlich",
  "39c3b8fa1d": "Einreichung Fehlgeschlagen",
  "3ea44d7963": "Hochladen Erfolgreich",
  "5b1aa3c2c4": "Upload fehlgeschlagen.",
  "7e7f81eaa3": "Hochladen Fehlgeschlagen, Datei Ist Größer Als 10MB",
  "2ff1913de1": "Upload fehlgeschlagen. Die Datei muss .jpg, .jpeg, .png, .bmp oder .pdf sein.",
  "7951a879f2": "Handelsregistereintrag Ist Erforderlich",
  "66bda65057": "Dateigröße Überschreitet 10 MB, Bitte Neu Auswählen",
  "8f2305a83d": "Rechtsbeschwerdeformular Ist Erforderlich",
  "55ff0c8c6e": "Einreichung Fehlgeschlagen",
  "8dad6d950d": "Einladung Informationen Abrufen Fehlgeschlagen",
  "a5f0ac3a9a": "Erstellung Erfolgreich",
  "4f1d069770": "Die UTMs Der Einladungsseite Sind {0} Und Name {1}",
  "f9578cfe6d": "Die UTMs Des Zwei-Schritt-Leitfadens Sind {0} Und Name {1}",
  "e10d028405": "Zwei-Schritt-Leitfaden Pcoffice Erstellt",
  "8e22e4fcc4": "Einladungslink Kopiert",
  "3f327f9f37": "Kopie Fehlgeschlagen, Bitte Erneut Versuchen",
  "bd1aecb265": "Abbrechen",
  "b6abf9b19a": "Akzeptieren",
  "e910d9cc0f": "Abbrechen",
  "37ab25522d": "Akzeptieren",
  "196b3eb9cf": "Mit QR-Code Beitreten",
  "2b81c52e20": "Bild Herunterladen",
  "62152fd9f3": "Link-Einladung",
  "e0a3725651": "Entschuldigung, Ihr Aktueller Browser Unterstützt Das Herunterladen Des QR-Codes Nicht",
  "8b7883b2c7": "Mit QR-Code Beitreten",
  "9e9a659ed5": "Bild Herunterladen",
  "0d55065a9a": "Link-Einladung",
  "487cf6a106": "Entschuldigung, Ihr Aktueller Browser Unterstützt Das Herunterladen Des QR-Codes Nicht",
  "78fd005d1f": "Bitte Geben Sie Die Telefonnummer Ein",
  "f909563857": "Mit Dieser Nummer Erstellen",
  "a26a19f139": "Erstellen Abbrechen",
  "cc004ac9ee": "Telefonnummer",
  "4df8c3c588": "Andere Telefonnummer Eingeben, Um Schule Zu Erstellen",
  "3151cabb3d": "Andere Telefonnummer Eingeben, Um Unternehmen Zu Erstellen",
  "56098a71eb": "Klicken Sie Auf Smart Verify, Um Einen Code Zu Senden",
  "e96ec218e4": "Bitte Geben Sie Den SMS-Code Ein",
  "ce619a0225": "SMS-Code Gesendet An",
  "0e9863aaeb": "Code Ist Falsch, Bitte Erneut Geben",
  "32dc8629e1": "Sekunden Bis Zum Erneuten Senden",
  "e4eda9add5": "Erneut senden",
  "b007977564": "Genehmigungsinformation Fehlgeschlagen",
  "d8852ffc9c": "Nicht-Administrator Zugriff",
  "8a733a2574": "Mobile Zugriff",
  "9e8c152c4f": "PC Zugriff",
  "2265a55e93": "Dienstleistungsvereinbarung akzeptieren",
  "80dabe5aa3": "Einrichtung erstellen",
  "7deee8bf5a": "Zweistufige Anleitung DocsWeb erstellt",
  "69eb501ecb": "Ihr Einspruch ist ungültig und kann nicht darauf zugreifen",
  "aa1d9d98ad": "Unzureichende Berechtigungen, kein Zugriff möglich",
  "fdf2fe129e": "Institution Erstellen",
  "7f0ca0df6b": "Gemeinsame Speicherorte ausblenden",
  "cc6ac2a93c": "Zweistufige Anleitung Basis montiert",
  "5d6c570bf0": "Zweistufige Anleitung vor dem Verlassen",
  "a4eb8a192d": "Teams, die alle erstellen",
  "4912e16a9d": "Firmenname wiederhergestellt",
  "41c4e87ef2": "Sie können auf den Link klicken",
  "5e630930c0": "Unternehmen Erneut Erstellen",
  "436a563524": "Wenn Sie ein Unternehmen erstellt haben, können Sie sich darauf beziehen",
  "0b6e7cbe7f": "Wie man den Firmennamen Ändert",
  "cb7bce0775": "Tutorial zum Ändern des Firmennamens",
  "3feadd3040": "Aktuelle Version zu niedrig, kann das Unternehmen nicht nutzen",
  "3cf23de936": "Ihre Softwareversion ist zu niedrig, Unternehmensfunktionen können nicht genutzt werden. Bitte aktualisieren Sie die Software über den App Store!",
  "a1c5d5d202": "OK",
  "e50183bd00": "WPS Cloud",
  "e5031ab679": "Sicherheit, Synchronisierung, Zusammenarbeit",
  "c870026dfc": "WeChat-Anmeldung",
  "e7647cd875": "WPS-Kontoanmeldung",
  "07b380074b": "QQ-Anmeldung",
  "67921724dd": "Andere Möglichkeiten",
  "254da8a9f5": "Beitritt/Erstellung von Unternehmen hat die Höchstgrenze erreicht",
  "3648e4811b": "Docs Eingeben",
  "dcd102b346": "Benutzerdefiniertes Team Erstellen",
  "8b9b258cbf": "Geben Sie hier den Teamnamen ein",
  "19bb6e0ded": "WPS Mitgliedsvorteile",
  "2d9fe8d938": "Geschäftliche Privilegien, helfen Ihnen bei der Lösung von täglichen Dokumentproblemen, erleben Sie es jetzt!",
  "e8c1caa649": "Von Lokal Hochladen",
  "03641083a3": "Aus 'Persönlichen Dokumenten' Verschieben",
  "eecd3ab9b5": "Nächstes Mal",
  "13b447b3a8": "Ersetzen",
  "3c2fc507fc": "Aktuelle Version zu niedrig, kann das Unternehmen nicht nutzen",
  "c3615d8134": "Ihre Softwareversion ist zu niedrig, Unternehmensfunktionen können nicht genutzt werden. Bitte aktualisieren Sie die Software über die offizielle Website!",
  "644a36e05b": "Aktualisieren",
  "d435105f21": "Beitritt/Erstellung von Unternehmen hat die Höchstgrenze erreicht",
  "73a286ceb0": "Docs Eingeben",
  "c2cec645c0": "Abbrechen",
  "b5f5b83c0f": "Akzeptieren",
  "76ec352da5": "Kollegen Über QR-Code Einladen",
  "6a509e4487": "QR-Code Herunterladen",
  "940cc4a546": "Unternehmen Kann Nicht Erstellt Werden",
  "78b2a62ea5": "In ein Bestehendes Unternehmen Eintreten oder Neues Unternehmen Erstellen",
  "3a6da7f6f9": "Aktuelle Anzahl der mit der Telefonnummer verbundenen Unternehmen hat die Höchstgrenze erreicht (maximal 5 Unternehmen)",
  "93bab52870": "Die aktuelle Telefonnummer ist bereits mit einem Unternehmen verbunden, Sie können ein bestehendes Unternehmen wählen, um sich anzumelden:",
  "ce6e0adaf2": "Sie können sich dafür entscheiden, in das unten verbundene Unternehmen einzutreten:",
  "1ce200a92b": "Auswählen",
  "bb91ef2999": "Neues Unternehmen Erstellen",
  "024e4a91e5": "Firmenname ist bereits registriert",
  "eb089a23a0": "Dieser Firmenname ist bereits registriert:",
  "7646558701": "Administrator:",
  "1d9c02bd33": "Registrierungsdatum:",
  "919fc7805f": "Wir empfehlen Ihnen, Ihre oben genannten Kollegen zu suchen und zu kontaktieren.",
  "0ca71a9344": "Sie können auch vorübergehend einen anderen Namen verwenden, um ein Unternehmen zu erstellen (später änderbar) und dann einen Einspruch einzureichen.",
  "e83a244e90": "Klicken Sie, um zu erfahren, wie Sie Einspruch erheben können.",
  "d22bedfb21": "Ja",
  "907b78b6e5": "Geben Sie den Namen der Arbeitsgruppe oder des Teams ein",
  "7195b0ac1e": "Teams, die Sie möglicherweise erstellen möchten",
  "60ed4f915e": "Weiter",
  "f5ba8dfb7b": "Einführung überspringen",
  "5c44a3ef68": "Maximal 100 Zeichen",
  "130c53fb20": "Der Name darf keine illegalen Zeichen und Sonderzeichen/\\;:*?\"<>|%& enthalten",
  "e832d41acc": "Zweischritt-Leitfaden überspringen",
  "80d9cf7177": "Zweischritt-Leitfaden aktualisieren",
  "0aebf80435": "Zweischritt-Leitfaden Label anklicken",
  "e74f515977": "Zweistufige Anleitung handleSubmit",
  "308d2a53c9": "Zweischritt-Leitfaden Gruppe erstellen",
  "dda2ed7e18": "Zweischritt-Leitfaden Team-Erstellung fehlgeschlagen",
  "ded3c35500": "Team-Erstellung fehlgeschlagen",
  "4f18031bc1": "Zweischritt-Leitfaden Vorlage erstellen",
  "091e5cefcc": "Zweischritt-Leitfaden Vorlagenfehler",
  "58cf4e00f0": "Verifizierungscode",
  "92abbf0385": "Verifizierungscode senden",
  "f0f9976ef9": "Bitte geben Sie Ihre Handynummer ein",
  "a4ce99b1df": "Verifizierungscode",
  "39d36e0f9f": "Bestätigen",
  "0fd8a01938": "Senden",
  "9048a4e842": "Telefonnummer",
  "9afa1091eb": "Nochmals senden",
  "58d787001f": "Geben Sie eine andere Handynummer ein, um eine Schule zu erstellen",
  "450905a265": "Geben Sie eine andere Handynummer ein, um ein Unternehmen zu erstellen",
  "f7386de3c6": "Ausklappmenü auswählen",
  "27aa05a92c": "Servicevereinbarung akzeptieren",
  "80af61cb57": "Zurück zur vorherigen Seite",
  "50149b8d4f": "Name des Antragstellers",
  "e6756f8749": "Bitte geben Sie Ihren Namen ein",
  "3cbd51a2b1": "Der Name muss mindestens 2 Zeichen enthalten, bitte geben Sie einen Namen mit 2 bis 10 Zeichen ein",
  "4f79b4813f": "Der Name unterstützt nur chinesische Schriftzeichen, Zahlen, englisch, ·",
  "71d3e75983": "Gängige Telefonnummer",
  "afe5149035": "Bitte geben Sie Ihre übliche Telefonnummer ein",
  "1e9270b50f": "Bitte geben Sie Ihre übliche Telefonnummer ein, 11 Ziffern",
  "ff5dc98dfb": "Überspringen",
  "165be2ab43": "Zurück zum vorherigen Schritt",
  "231d8a335a": "Servicevereinbarung akzeptieren",
  "1cad008ffc": "Firmenname {0} wurde bereits registriert, bitte verwenden Sie einen anderen Namen",
  "c6e274fcab": "Vereinbarung bestätigen",
  "b9352504bb": "Vereinbarungsfenster schließen",
  "8409e99ad0": "Vereinbarungsfenster öffnen",
  "1593c6dd95": "Senden",
  "4f44a9de22": "SMS-Überprüfung öffnen",
  "26b70c68b8": "Überspringen, direkt ins Unternehmen eintreten",
  "a8bebcb302": "Zurück zur vorherigen Seite",
  "c800b4fec5": "Einladungsseite Base Mounted",
  "38b396d5b0": "Einladungsseite docsWeb Mounted",
  "2eb7f9a9f1": "Ihr Einspruch wurde erfolgreich eingereicht",
  "2c6f3590fb": "Wir erwarten, dass wir das Behandlungsergebnis innerhalb von 3 Werktagen an Ihre E-Mail-Adresse senden",
  "2ea3eff708": ", bitte achten Sie auf Ihre Nachrichten.",
  "53acfba22c": "Laden Sie jetzt Mitarbeiter ein",
  "4e6d282f4f": "Unternehmens-Einladung beitreten",
  "5f72f4b936": "Laden Sie jetzt Mitarbeiter ein",
  "e5383077ba": "Unternehmensname Abrufen",
  "06e3fa2350": "Nach Abfrage,",
  "653a263b5e": "Der Ersteller ist",
  "769f57269f": "Die Telefonnummer des Erstellers ist",
  "09a224695e": "Bitte Bestätigen Sie, Ob Der Unternehmensgründer Ein Kollege Von Ihnen Ist",
  "3beda6c149": "Wenn Es Sich Um Ihren Kollegen Handelt, Können Sie Ihn Kontaktieren",
  "5c74dd10d1": "Firmenname Ändern Oder Superadministrator Übertragen",
  "da504edb0f": "Wenn Es Nicht Ihr Kollege Ist, Können Sie Unten Auf Die Schaltfläche Klicken, Um Weiter Mit Der Wiederherstellung Des Firmennamens Fortzufahren",
  "39194faaf1": "Weiter Mit Der Wiederherstellung Des Firmennamens",
  "e22b829e90": "Erfolgreich kopiert",
  "6e1b44752a": "TXT-Wert",
  "79881b1d7a": "Kollegen Sofort Einladen",
  "a5344a45f9": "Klicken Sie oben rechts und wählen Sie „An Freund senden“",
  "a4954a5b08": "Kollegen Sofort Einladen",
  "8e3a1625fb": "Firmennamen Wiederherstellen",
  "bf8b8c7005": "Firmen Geschäftsregistrierung Hochladen",
  "bfd44a66c9": "Zum Auswählen Klicken",
  "d503f20925": "Bitte Laden Sie Einen Scan Oder Ein Foto Des Firmen Geschäftsregistrierung Hoch",
  "cbebe043c5": "Unterstützt JPG-, JPEG-, PNG-, BMP-, PDF-Format, Größe Nicht Über 10 MB.",
  "9650b96d7d": "Beschwerdetabelle Bei Namensgleichheit Hochladen",
  "c3b8ae46d3": "Bitte Laden Sie Einen Scan Oder Ein Foto Der Beschwerdetabelle Bei Namensgleichheit Hoch",
  "9e325a9e09": "Laden Sie Das Vorlagenformular Der Informationen Herunter",
  "a4711aae88": "Bewerbung Einreichen",
  "3a5cc1441e": "Wird Zertifiziert...",
  "0bd7bf8511": "Wir Können Ihre Domain Derzeit Nicht Verifizieren, Möglicherweise Müssen Sie Einige Zeit Warten, Bis Ihr Domain-Hosting-Dienstleister Ihre Informationen Aktualisiert Hat. Wenn Nach Einem Zeitraum Noch Keine Änderung Erkennbar Ist, Versuchen Sie Erneut Zu Verifizieren Oder Verwenden Sie Eine Andere Domain.",
  "fae48d554b": "Überprüft Die Domain",
  "5e1779a0ca": "Bestätigungsdatensätze, Sie Können Diese Seite Schließen Und Später Zurückkehren.",
  "ca85f8b836": "Willkommen Bei Der Unternehmensversion",
  "2570e0f00b": "Anmeldung fehlgeschlagen.",
  "40d16a007e": "Ihr Persönliches Konto Ist Automatisch Gebunden",
  "81376b92e4": "{0} Anmeldemethode, Bitte Melden Sie Sich Erneut An, Um Auf Das Unternehmenskonto Umzuschalten.",
  "ba679ba739": "Verstanden, Zum Login",
  "c05f64c6c6": "{0} Dann Automatisch Zum Login Weiterleiten",
  "c329ccef3a": "Anmeldung fehlgeschlagen.",
  "e370f9afb1": "Ihr Persönliches Konto Ist Automatisch Gebunden",
  "410cf42585": "Anmeldemethode, Bitte Melden Sie Sich Erneut An, Um Auf Das Unternehmenskonto Umzuschalten.",
  "062d48aece": "Verstanden, Zum Login",
  "95a105d412": "Danach Automatisch Zum Login Weiterleiten",
  "2d000d5a6d": "Senden Sie Einen Freigabelink An Mitglieder, Die Öffnen Und Sich Bewerben Können, Beizutreten",
  "8861b6e90d": "Ins Unternehmen Eintreten",
  "25b9f72fda": "Fehlerhafte Seitenparameter",
  "1c76123efc": "Einladungslink Abrufen Fehlgeschlagen",
  "6caba48b76": "Überspringen",
  "f66379c650": "Fehlerhafte Seitenparameter",
  "c45021de2a": "Erstellung fehlgeschlagen.",
  "011d470126": "Plattform Schützt Ihre Informationen Kontinuierlich",
  "f1a44d9151": "Die Plattform Hat Die ISO27001-, ISO27701-Zertifizierung, Ausgestellt Von Der Internationalen BSI, Erhalten Und Die Drittgrad-Sicherheitsbewertung Des Staates Bestanden.",
  "255ea5dff7": "Whitepaper über Sicherheit",
  "bb55b124f2": "Unternehmenspräsentation erstellen",
  "61e24974a3": "Strategieinhalte für Unternehmen erstellen",
  "bfdf78febe": "Weiter, vervollständigen Sie die Informationen",
  "c4aa2d2d60": "Geben Sie den Namen der Arbeitsgruppe oder des Projekts ein",
  "b69765ab64": "Teams, die alle erstellen",
  "9657d9408b": "Ersetzen",
  "e21da8c16a": "Weiter",
  "224ef5cc9f": "Einführung überspringen",
  "641f58c8f6": "Das aktuelle Unternehmen unterstützt keine Teammitglieder, bitte den Administratoren für die Erstellung kontaktieren",
  "efea622752": "Link kopieren, Kollegen einladen",
  "fd5b40a9fd": "Einladung zur Zusammenarbeit an „{0}“",
  "b04dd2f10a": "Einladungslink kopiert",
  "d1606a1b1a": "Kopieren fehlgeschlagen, bitte versuchen Sie es erneut",
  "0d59f3db83": "Geben Sie die Abteilung oder das Team ein, z.B. „Vertrieb“",
  "9429513d34": "Keine Einführung erforderlich",
  "b54a20b1ff": "Erstellung fehlgeschlagen.",
  "093fa0fb74": "Anmeldung wird autorisiert...",
  "b383b136f4": "Projektinitialisierung für Unternehmen erstellen",
  "b6b21b388b": "Unternehmensname ist bereits registriert",
  "285dc68c10": "Dieser Unternehmensname ist bereits registriert:",
  "1bf685b89d": "Administrator:",
  "7b4297edcc": "Registrierungszeit:",
  "fa51ea19fc": "Es wird empfohlen, dass Sie versuchen, mit Ihren Kollegen in Kontakt zu treten.",
  "e3678a996d": "Sie können auch vorübergehend einen anderen Namen für das Unternehmen wählen (später änderbar) und dann eine Beschwerde einreichen.",
  "5969bc8071": "Alles klar",
  "ba4cf699df": "Unternehmensname wiederherstellen",
  "afecee4eb4": "Ihr Name",
  "a8bdebc614": "Bitte geben Sie Ihren Namen ein",
  "5bbeb38a66": "Telefon",
  "b4f7b44b7a": "Bitte geben Sie Ihre Telefonnummer ein",
  "cac2913686": "Kontakt E-Mail",
  "23d3bb3a42": "Bitte geben Sie Ihre E-Mail-Adresse ein",
  "ea106a393c": "Unternehmensgeschäftslizenz hochladen",
  "f74131d71e": "Klicken Sie, um auszuwählen",
  "53749c51c5": "Bitte laden Sie den Scan oder das Foto der Unternehmensgeschäftslizenz hoch",
  "c00f2ea171": "Unterstützte Formate: JPG, JPEG, PNG, BMP, PDF, Größe nicht mehr als 10 MB.",
  "57ec07fa97": "Informationstabelle zur Namensbeschwerde hochladen",
  "8eb0606e94": "Bitte laden Sie den Scan oder das Foto der Informationstabelle zur Namensbeschwerde hoch",
  "f59e76c0b0": "Download der Vorlage",
  "030bd26fa4": "Bewerbung einreichen",
  "0a602dc727": "Sichere Speicherung von Informationen",
  "9138f28acf": "Dateifreigabe und Zusammenarbeit",
  "b3a306cf90": "Compliance und Legalität",
  "973c53f725": "Es wird empfohlen, den Namen zu ändern, nach der Registrierung können Sie die Institution Zertifizierung einreichen und den Namen aktualisieren",
  "f886f5e92f": "Es wird empfohlen, den Namen zu ändern, nach der Registrierung können Sie die Unternehmenszertifizierung einreichen und den Namen aktualisieren",
  "b8051702a3": "Dieser Name enthält sensible Wörter, bitte passen Sie den Namen an oder kontaktieren Sie den Kundendienst",
  "d73881f7d4": "Unternehmensname geschützt",
  "dc7e58e320": "Unternehmensname geschützt, vor der Verwendung muss die Identitätsinformation überprüft werden. Es wird empfohlen, den Unternehmensnamen zu ändern oder nach der Registrierung durch Unternehmenszertifizierung den Namen zu verwenden.",
  "20c3bc070c": "Bestätigen",
  "c4278e5f28": "Unzureichende Berechtigungen",
  "9217efae21": "Das angemeldete Konto hat keine Berechtigung zur Erstellung. Bitte kontaktieren Sie den Vertriebsmitarbeiter.",
  "52ff08f2ad": "Der Name der Behörde ist geschützt. Bitte ändern Sie den Unternehmensnamen.",
  "79386ae280": "Bitte geben Sie den 6-stelligen Bestätigungscode ein.",
  "d7b2c5a41b": "Der Bestätigungscode wurde gesendet an",
  "ce2e1c26f7": "(Gültig für 10 Minuten)",
  "59d338903f": "{0} Sekunden vor dem erneuten Abrufen des Bestätigungscodes",
  "5aadd14136": "Bestätigungscode erneut abrufen",
  "90f5c93432": "Dieser Name ist bereits registriert",
  "1677072f4a": "Sie können weitere Informationen hinzufügen oder einen anderen Namen zur Registrierung verwenden",
  "3b8459fb1e": "Schnell füllen:",
  "6f38edbcb1": "Unter diesem Namen registrieren",
  "8406c81e2d": "Filiale",
  "29d323fa85": "Niederlassung",
  "4f0e806e02": "Finanzabteilung",
  "3f935efb6b": "Dienstleistungsvereinbarung zustimmen",
  "b42241be05": "Später",
  "99de4b33b7": "Akzeptieren",
  "7f867e7395": "Anderes Mobiltelefon verwenden, um Unternehmen zu erstellen",
  "0d51a8f7a6": "Erstellung fortsetzen",
  "8bdaecf2e5": "Bitte geben Sie Ihre Mobiltelefonnummer ein.",
  "565ae60c8a": "Bitte geben Sie Ihren Namen ein.",
  "f76e06d0e7": "Bitte geben Sie Ihre Mobiltelefonnummer ein.",
  "7b0fca5255": "Bitte geben Sie den Bestätigungscode ein.",
  "68026d2d25": "Willkommen in der Unternehmensversion",
  "d25b5541be": "Kostenlos erstellen",
  "32cfd73733": "Bitte geben Sie den Namen des Teams, Unternehmens oder der Organisation ein.",
  "4cf83dc4a0": "Minutenschnelle Erstellung, effiziente Zusammenarbeit mit Kollegen",
  "d320d37116": "Team/Unternehmen kostenlos erstellen",
  "c54b475dd2": "Nutzungsbedingungen",
  "190d54e616": "{0}s Unternehmen",
  "8c1b768ac4": "Intelligente Überprüfung fehlgeschlagen",
  "d74eab0f35": "Der von Ihnen angegebene Unternehmensname entspricht nicht den Plattformrichtlinien. Bitte ändern Sie ihn und versuchen Sie es erneut.",
  "0f3d62dd4f": "Der von Ihnen angegebene Name entspricht nicht den Plattformrichtlinien. Bitte ändern Sie ihn und versuchen Sie es erneut.",
  "647cf2211b": "Die Erstellung mit der aktuellen Mobiltelefonnummer wird nicht unterstützt. Bitte ändern Sie die Telefonnummer.",
  "b63d96cdae": "Die angegebenen Informationen entsprechen nicht den Plattformrichtlinien. Bitte ändern Sie sie und versuchen Sie es erneut.",
  "2dbbe8e43f": "Die Erstellung mit der aktuellen Mobiltelefonnummer wird nicht unterstützt. Bitte ändern Sie die Telefonnummer.",
  "b18abc5de6": "Keine gebundene Telefonnummer",
  "f5233dae6f": "Bitte ändern Sie die Telefonnummer, um das Unternehmen zu erstellen.",
  "4167c8b88d": "Die aktuelle Telefonnummer weist möglicherweise folgende Probleme auf. Bitte versuchen Sie, die Telefonnummer zu ändern, um das Unternehmen zu erstellen. Bei Fragen kontaktieren Sie bitte den Kundenservice.",
  "a8a2433c4d": "Scannen Sie den QR-Code, um den Kundenservice zu kontaktieren.",
  "444a639c09": "Ich verstehe",
  "69a097057f": "Die aktuelle Telefonnummer gehört zu einem virtuellen Betreiber.",
  "4370b06fd0": "Die aktuelle Telefonnummer weist ungewöhnliches Nutzungsverhalten auf.",
  "8c49e1dc4a": "Mensch-Maschine-Verifizierung erforderlich",
  "4b8ba7d8cc": "Neue Produktivitätsplattform für das Büro",
  "81be771e17": "🎉Das Unternehmen wurde erfolgreich erstellt! Vervollständigen Sie die Informationen, um exklusive Dienstleistungen zu erhalten.",
  "461125b057": "Dokumente und Materialien können im Team verwaltet werden. Teammitglieder können sie bequem einsehen und Bearbeitungs-/Download-Berechtigungen setzen, um die Datensicherheit zu gewährleisten.",
  "c3eb25029b": "Größe Ihres Unternehmens/Ihrer Organisation",
  "049f8401ec": "Unter 5 Personen",
  "c81896349e": "6-20 Personen",
  "7357daac4e": "21-50 Personen",
  "f0e65a0a29": "51-100 Personen",
  "b9fac8204a": "101-200 Personen",
  "62d73dddaf": "201-500 Personen",
  "3bcdaf7160": "501-2000 Personen",
  "ab0b2333fe": "Mehr als 2000 Personen",
  "4f756eedc8": "Ihre Rolle ist",
  "3ba0b502c3": "Geschäftsführer",
  "702099cc72": "Finanzen",
  "843b603162": "Einkauf",
  "8b414a9b44": "Personal/Verwaltung",
  "92486b2908": "Vertrieb",
  "ac4e7fb063": "Hat Ihre Organisation ein Budget/einen Kaufplan für Bürosoftware",
  "37634c72dc": "Innerhalb eines halben Jahres",
  "bd94b6deec": "Innerhalb eines Jahres",
  "713f4aad5c": "Wird in Erwägung gezogen",
  "c5ea095a4d": "Kein Plan",
  "2409099a69": "<img src=\"https://ks3-wpsplus-prod.wpscdn.cn/e2546275-3953-40b4-8933-9ff6f0a1aeb4.png\"> Erstellen Sie ein Team und laden Sie Mitglieder zur Zusammenarbeit ein.",
  "9d27dc2d90": "Sie können den Namen Ihres Teams oder das neueste Projekt eingeben, an dem Sie interessiert sind",
  "de19c8509a": "Sie möchten möglicherweise folgendes erstellen:",
  "1a84699223": "Vertriebsabteilung",
  "efab59502b": "Produktabteilung",
  "7e599b3713": "Südlicher Betrieb",
  "bf494779c2": "Einkaufsabteilung",
  "f3a60ab34d": "Verwaltungsabteilung",
  "bbc50c1ac8": "Nördlicher Finanzbereich",
  "32629e3dac": "Produktfinanzen",
  "5524d354ba": "IT-Abteilung",
  "0ccda29a0d": "🎁<span style='color: rgb(206,131,62);'>Sie haben die Anfängervorteile freigeschaltet!</span> Laden Sie 3 weitere Personen ein und erhalten <span style='color: rgb(206,131,62);'>4T Speicherplatz und WPS AI</span>-Rechte.",
  "939eb98492": "<span style='color: rgb(206,131,62);'>Sie haben das Limit von 50 Personen und das 4G Einzeldatei-Upload-Recht freigeschaltet.</span> Laden Sie 3 weitere Personen ein, um günstige 30 Tage WPS AI und 4T Speicherplatz zu erhalten.",
  "136c26d941": "Kopieren Sie den folgenden Link, um Mitglieder einzuladen",
  "3de5c12558": "Link kopieren und Kollegen einladen",
  "a5d64b14f3": "Unternehmensinformationführung",
  "b8f2492701": "Unternehmensinformationssammlung",
  "1f9d053dc0": "Teamvorlage erstellen",
  "0e83c79a88": "Mitglieder einladen",
  "821fc1906a": "Unternehmen betreten",
  "463e14ae9c": "Bitte wählen Sie ein Team",
  "690f0cdb9e": "Symbol abschließen",
  "c340522a17": "Zurück",
  "f9355c72ef": "Überspringen",
  "bd6c09ebbb": "Weiter",
  "2a2603cd3f": "QR-Code scannen, um Kollegen einzuladen",
  "411e64907a": "Kopieren",
  "b0d988cf23": "Herunterladen",
  "e3c0b650ac": "Erfolgreich kopiert",
  "713ac624b4": "Willkommen bei WPS 365",
  "b8fff97849": "Ungültiges Zielobjekt",
  "02acdcf296": "html2canvas-Konvertierung fehlgeschlagen, kein Canvas generiert",
  "a76988c496": "Canvas zu Blob-Konvertierung fehlgeschlagen",
  "af89584edf": "Zwischenablage-API nicht verfügbar",
  "f90263bbde": "Bildkopie fehlgeschlagen",
  "71b05319da": "HTML zu Canvas-Konvertierung fehlgeschlagen",
  "38852999fe": "Speichern von Informationen fehlgeschlagen",
  "4a4c621d07": "Team konnte nicht erstellt werden, bitte versuchen Sie es später erneut",
  "d239a23994": "Die aktuelle Seite ist nur für Unternehmenskonten zugänglich, bitte melden Sie sich zuerst mit Ihrem Unternehmenskonto an.",
  "d93bfb7fb9": "Bitte Inhalt eingeben",
  "42b81a66c4": "Länge zwischen 2 und 100 Zeichen",
  "76d33733db": "Darf keine Sonderzeichen wie / \\ ; : * ? \" < > | % & enthalten",
  "dc55d1f62f": "Erleben",
  "b25233cba0": "Dokumentenzusammenarbeit + Sofortnachrichten, starten Sie eine neue Art des effizienten Arbeitens.",
  "f0e563652d": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Starten Sie Gruppen-Chats zur Zusammenarbeit, Dokumentenfreigabe ist sicher und bequem.",
  "1e484cce68": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/lingxi_normal.png\"> Lingxi KI-Assistent, der speziell für das Büro geborene smarte Assistent.",
  "e338385bc9": "Native Office Intelligenter Agent, Tiefe Integration von KI und Bürosoftware, Ermöglicht jedem einen KI-Assistenten zu haben",
  "7ae1f3b1c6": "Datei(en) importiert, Ergebnisse im „Meine AirPage“ verfügbar",
  "85db2a024a": "Datei(en) Importieren nicht erfolgreich, Bitte später erneut versuchen",
  "9ff74c802a": "Herunterladen Intel Chip Version",
  "ab44928f02": "Herunterladen Apple Chip Version",
  "a08d937c38": "Datei(en) wird hochgeladen, Nach Abschluss im „Meine AirPage“ verfügbar",
  "68db1829fa": "Support nur Import aus persönlichen Konten, Bitte nach dem Einloggen erneut versuchen.",
  "1185a7c7ab": "Weniger als 20 Personen",
  "e2bcc252c9": "21-300 Personen",
  "3c4842f1ea": "301-1000 Personen",
  "1bbee64cfa": "Mehr als 1000 Personen",
  "388ff4a035": "Lehrer",
  "d341b1d794": "Student",
  "bfb2ee4148": "Mehr",
  "f6450c3f31": "Projektmanagement",
  "b87fd33a0d": "Jahresplanung",
  "0dd45a1c14": "Mitarbeiter Leistungsmanagement",
  "67fa01cac6": "Marktaktivitäten",
  "6dd82cc031": "Mitarbeiter Rekrutierung",
  "a7edaed91d": "Lehrmaterial",
  "bf12b7efb0": "Lehrplanung",
  "c35ae8f358": "Produktdokumentation",
  "343f236a78": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/dbsheet.png\"> WPS PivotTable, Visuelle Erstellung eines maßgeschneiderten Geschäftssystems",
  "72286d5519": "Empfohlene Vorlage",
  "0bc00ee949": "Bedarfsmängelverwaltung",
  "e22f3d56f7": "Inhaltskreationsverwaltung",
  "dd439de3dd": "Kundenverwaltungssystem",
  "fbb2bbf82e": "Prüfungsvorbereitungsplanung",
  "0645b908bc": "Gehaltsabrechnung Abfrage",
  "813b3d3d7e": "OKR Verwaltung",
  "918e33d5bd": "Ein Klick Erstellen",
  "ebf9cfb7ef": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/import_files.png\"> Importieren gebräuchliche Dokumente, Verwendung erleichtert",
  "c58f28713c": "Von lokal importieren",
  "9d6a0a4370": "Unterstützt Office häufig Dateiformate",
  "54c48aee85": "Datei auswählen",
  "c5b593e452": "Von persönliche Konto importieren",
  "4bdcd9d4c5": "Ein Klick Import persönliche Kontodokumente, Teams, Ordner",
  "99b2968905": "Berechtigungsimport",
  "472f818a23": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> WPS Teams-Client Herunterladen",
  "fe46574227": "Dokumentenkollaboration + Sofortnachrichten, neue effiziente Arbeitsweise",
  "beefe5a09b": "Download starten. - ja.",
  "278839c7b1": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Vielfältige Sicherheitseinstellungen, um Datensicherheit zu gewährleisten",
  "b4e70dbeab": "Jahrelange Erfahrung in der Dokumentsicherheit von WPS, um zu gewährleisten, dass wichtige Unternehmensdaten nicht austreten",
  "42dc772619": "Datei zu groß, bitte später auf der Startseite erneut importieren",
  "a052564e47": "Erstellen fehlgeschlagen, bitte versuchen Sie es später erneut",
  "790d0c428c": "Zum Arbeitsplatz Gehen"
}